var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIblLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 48.6",
    style: {
      enableBackground: "new 0 0 79 48.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02538A;}\r\n\t.st1{fill:#DE2B1F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,13.4h7L18.2,36h-7L15.8,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,13.4h13.1c2.2,0,3.7,0.5,4.7,1.6c0.9,1.1,1.2,2.4,0.9,4c-0.3,1.3-0.9,2.5-2,3.4 c-0.7,0.6-1.6,1.1-2.7,1.5c1.5,0.4,2.6,1.1,3.2,2c0.6,1,0.7,2.1,0.4,3.6c-0.2,1.2-0.7,2.2-1.5,3.2c-0.7,0.9-1.6,1.7-2.7,2.2 c-0.7,0.3-1.6,0.6-2.8,0.7c-1.6,0.2-2.7,0.3-3.2,0.3H23.2L27.9,13.4z M31.2,31.2h3.6c1.2,0,2.1-0.2,2.7-0.6c0.6-0.4,0.9-1,1.1-1.7 c0.1-0.7,0-1.2-0.4-1.6c-0.4-0.4-1.2-0.6-2.4-0.6h-3.5L31.2,31.2z M33.1,22.3h3c1.1,0,1.9-0.2,2.4-0.6c0.5-0.4,0.8-0.9,1-1.6 c0.1-0.7,0-1.2-0.3-1.5C38.8,18.2,38.1,18,37,18H34L33.1,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.4,13.4h7l-3.5,17h10.9L65.6,36H47.7L52.4,13.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.1,48.6 0,48.6 10.1,0 12.2,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.9,48.6 66.8,48.6 76.8,0 79,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIblLogo);
export default __webpack_public_path__ + "static/media/ibl-logo.05218752f3b97d33ab65168e1751fccc.svg";
export { ForwardRef as ReactComponent };